"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var MetaLogPanel = /** @class */ (function () {
    function MetaLogPanel(panel) {
        this.panel = panel;
    }
    MetaLogPanel.prototype.selectedFeasiblePanel = function (term) {
        var selectedFeasiblePanel = this.panel.filter(function (panelItem) {
            return panelItem.Feasible == true && panelItem.NumberOfTerms == term;
        });
        return selectedFeasiblePanel[0];
    };
    MetaLogPanel.prototype.allFeasiblePanels = function () {
        var feasiblePanels = this.panel.filter(function (panelItem) {
            return panelItem.Feasible == true;
        });
        return feasiblePanels;
    };
    MetaLogPanel.getSelectedTerm = function (allFeasiblePanels) {
        for (var a = allFeasiblePanels.length - 1; a >= 0; a--) {
            if (allFeasiblePanels[a].Feasible === true) {
                return allFeasiblePanels[a].NumberOfTerms;
            }
        }
    };
    return MetaLogPanel;
}());
exports.MetaLogPanel = MetaLogPanel;
var PointProducer = /** @class */ (function () {
    function PointProducer() {
    }
    PointProducer.prototype.thousandPointsFrom = function (distribution) {
        var pointData = [];
        for (var y = 0.001; y < 1; y += 0.001) {
            try {
                var x = distribution.cdfInverse(y);
            }
            catch (e) {
                console.error("Could not calculate CDF Inverse of " + y);
                throw e;
            }
            try {
                var pdf = distribution.pdf(y);
            }
            catch (e) {
                console.error("Could not calculate PDF of " + y);
                throw e;
            }
            if (!isNaN(x) && x != -Infinity) {
                var cdfPoint = {
                    x: x,
                    y: y
                };
                var pdfPoint = { x: x, y: pdf };
                pointData.push({ cdfPoint: cdfPoint, pdfPoint: pdfPoint });
            }
        }
        return pointData;
    };
    return PointProducer;
}());
exports.PointProducer = PointProducer;
var MVSFromDistribution = /** @class */ (function () {
    function MVSFromDistribution(points) {
        this.points = points;
    }
    MVSFromDistribution.prototype.mvs = function () {
        var mean = this.mean();
        return {
            mean: mean,
            variance: this.variance(mean),
            skewness: this.skewness(mean)
        };
    };
    MVSFromDistribution.prototype.moment = function (i, mean) {
        var _this = this;
        return this.points.map(function (point) {
            return point.cdfPoint;
        }).reduce(function (total, point) {
            return total + Math.pow(point.x - mean, i) / _this.points.length;
        }, 0);
    };
    MVSFromDistribution.prototype.mean = function () {
        return this.moment(1, 0);
    };
    MVSFromDistribution.prototype.variance = function (mean) {
        return this.moment(2, mean);
    };
    MVSFromDistribution.prototype.skewness = function (mean) {
        return this.moment(3, mean);
    };
    return MVSFromDistribution;
}());
exports.MVSFromDistribution = MVSFromDistribution;
var Distribution = /** @class */ (function () {
    function Distribution() {
    }
    Distribution.prototype.ten = function () {
        return this.cdfInverse(0.1);
    };
    Distribution.prototype.fifty = function () {
        return this.cdfInverse(0.5);
    };
    Distribution.prototype.ninety = function () {
        return this.cdfInverse(0.9);
    };
    Distribution.prototype.tenFiftyNinety = function () {
        return {
            ten: this.ten(),
            fifty: this.fifty(),
            ninety: this.ninety()
        };
    };
    return Distribution;
}());
var Poland = /** @class */ (function (_super) {
    __extends(Poland, _super);
    function Poland(constants) {
        var _this = _super.call(this) || this;
        _this.sigma = constants.sigma;
        _this.mu = constants.mu;
        _this.mean = constants.mean;
        _this.reflect = constants.reflect;
        _this.mean0 = constants.mean0;
        _this.gaussian = new Gaussian();
        return _this;
    }
    Poland.prototype.cdfInverse = function (p) {
        if (this.sigma === 0) {
            return this.mu;
        }
        else {
            // mctad.log
            return this.mean - this.reflect * this.mean0 + this.reflect * this.gaussian.loginv(p * this.reflect + (this.reflect === -1 ? 1 : 0), this.mu, this.sigma);
        }
    };
    Poland.prototype.cdf = function (x) {
        var σ2 = this.sigma * this.sigma;
        return this.gaussian.lognormalCdf(this.reflect * (x - (this.mean - this.reflect * this.mean0)), this.mu, σ2);
    };
    Poland.prototype.pdf = function (p) {
        var x = this.cdfInverse(p);
        var σ2 = this.sigma * this.sigma;
        return this.gaussian.lognormalPdf(this.reflect * (x - (this.mean - this.reflect * this.mean0)), this.mu, σ2);
    };
    Poland.prototype.ID = function () {
        return "Poland";
    };
    return Poland;
}(Distribution));
exports.Poland = Poland;
var Gaussian = /** @class */ (function () {
    function Gaussian() {
    }
    Gaussian.prototype.normsinv = function (p, mu, sigma) {
        if (p < 0 || p > 1)
            throw new Error("The probality p must be bigger than 0 and" +
                " smaller than 1, but was " + p);
        if (sigma < 0)
            throw new Error("The standard deviation sigma must be positive");
        if (p == 0)
            throw new Error("Cannot handle p=0 as that returns negative" +
                " infinity");
        if (p == 1)
            throw new Error("Cannot handle p=1 as that returns infinity");
        if (sigma == 0)
            return mu;
        var q = p - 0.5;
        var r;
        var val;
        /* 0.075 <= p <= 0.925 */
        if (Math.abs(q) <= .425) {
            r = .180625 - q * q;
            val =
                q * (((((((r * 2509.0809287301226727 +
                    33430.575583588128105) * r + 67265.770927008700853) * r +
                    45921.953931549871457) * r + 13731.693765509461125) * r +
                    1971.5909503065514427) * r + 133.14166789178437745) * r +
                    3.387132872796366608)
                    / (((((((r * 5226.495278852854561 +
                        28729.085735721942674) * r + 39307.89580009271061) * r +
                        21213.794301586595867) * r + 5394.1960214247511077) * r +
                        687.1870074920579083) * r + 42.313330701600911252) * r + 1);
        }
        /* closer than 0.075 from {0,1} boundary */
        else {
            /* r = min(p, 1-p) < 0.075 */
            if (q > 0) {
                r = 1 - p;
            }
            else {
                r = p;
            }
            r = Math.sqrt(-Math.log(r));
            /* r = sqrt(-log(r))  < ==>  min(p, 1-p) = exp( - r^2 ) */
            if (r <= 5) { /* <==> min(p,1-p) >= exp(-25) ~= 1.3888e-11 */
                r += -1.6;
                val = (((((((r * 7.7454501427834140764e-4 +
                    .0227238449892691845833) * r + .24178072517745061177) *
                    r + 1.27045825245236838258) * r +
                    3.64784832476320460504) * r + 5.7694972214606914055) *
                    r + 4.6303378461565452959) * r +
                    1.42343711074968357734)
                    / (((((((r *
                        1.05075007164441684324e-9 + 5.475938084995344946e-4) *
                        r + .0151986665636164571966) * r +
                        .14810397642748007459) * r + .68976733498510000455) *
                        r + 1.6763848301838038494) * r +
                        2.05319162663775882187) * r + 1);
            }
            else { /* very close to  0 or 1 */
                r += -5;
                val = (((((((r * 2.01033439929228813265e-7 +
                    2.71155556874348757815e-5) * r +
                    .0012426609473880784386) * r + .026532189526576123093) *
                    r + .29656057182850489123) * r +
                    1.7848265399172913358) * r + 5.4637849111641143699) *
                    r + 6.6579046435011037772)
                    / (((((((r *
                        2.04426310338993978564e-15 + 1.4215117583164458887e-7) *
                        r + 1.8463183175100546818e-5) * r +
                        7.868691311456132591e-4) * r + .0148753612908506148525)
                        * r + .13692988092273580531) * r +
                        .59983220655588793769) * r + 1);
            }
            if (q < 0.0) {
                val = -val;
            }
        }
        return mu + sigma * val;
    };
    Gaussian.prototype.loginv = function (p, mu, sigma) {
        return Math.exp(mu + sigma * this.normsinv(p, 0, 1));
    };
    Gaussian.prototype.lognormalPdf = function (x, mean, variance) {
        return typeof mctad.lognormal(mean, variance) != 'undefined' ? mctad.lognormal(mean, variance).pdf(x) : 0;
    };
    Gaussian.prototype.lognormalCdf = function (x, mean, variance) {
        return typeof mctad.lognormal(mean, variance) != 'undefined' ? mctad.lognormal(mean, variance).cdf(x) : 0;
    };
    return Gaussian;
}());
var MetaLog = /** @class */ (function (_super) {
    __extends(MetaLog, _super);
    function MetaLog(coefficients) {
        var _this = _super.call(this) || this;
        _this.coefficients = typeof coefficients != 'undefined' ? coefficients : [];
        _this.numberOfTerms = _this.coefficients.length;
        return _this;
    }
    MetaLog.prototype.ID = function () {
        return "Metalog";
    };
    MetaLog.prototype.a = function (index) {
        return this.coefficients[index - 1];
    };
    MetaLog.prototype.cdfInverse = function (y) {
        return this.cdfCalc(y, this.numberOfTerms);
    };
    MetaLog.prototype.pdf = function (y) {
        return this.pdfCalc(y, this.numberOfTerms);
    };
    MetaLog.prototype.cdfCalc = function (y, n) {
        switch (n) {
            case 2:
                return this.cdf2(y);
            case 3:
                return this.cdf3(y);
            case 4:
                return this.cdf4(y);
            case 5:
            case 7:
            case 9:
                return this.cdfOdd(y, n);
            case 6:
            case 8:
            case 10:
                return this.cdfEven(y, n);
        }
        return 0;
    };
    MetaLog.prototype.pdfCalc = function (y, n) {
        switch (n) {
            case 2:
                return this.pdf2(y);
            case 3:
                return this.pdf3(y);
            case 4:
                return this.pdf4(y);
            case 5:
            case 7:
            case 9:
                return this.pdfOdd(y, n);
            case 6:
            case 8:
            case 10:
                return this.pdfEven(y, n);
        }
        return 0;
    };
    MetaLog.prototype.logTerm = function (y) {
        return Math.log(y / (1 - y));
    };
    MetaLog.prototype.cdf2 = function (y) {
        return this.a(1) + this.a(2) * this.logTerm(y);
    };
    MetaLog.prototype.pdf2 = function (y) {
        return y * (1 - y) / this.a(2);
    };
    MetaLog.prototype.cdf3 = function (y) {
        return this.cdf2(y) + this.a(3) * (y - 0.5) * this.logTerm(y);
    };
    MetaLog.prototype.term3 = function (y) {
        return this.a(2) / (y * (1 - y)) + this.a(3) * ((y - 0.5) / (y * (1 - y)) + this.logTerm(y));
    };
    MetaLog.prototype.pdf3 = function (y) {
        return 1 / this.term3(y);
    };
    MetaLog.prototype.cdf4 = function (y) {
        return this.cdf3(y) + this.a(4) * (y - 0.5);
    };
    MetaLog.prototype.pdf4 = function (y) {
        return 1 / (this.term3(y) + this.a(4));
    };
    MetaLog.prototype.cdfOdd = function (y, n) {
        return this.cdfCalc(y, n - 1) + this.a(n) * Math.pow(y - 0.5, (n - 1) / 2.0);
    };
    MetaLog.prototype.pdfOdd = function (y, n) {
        return 1 / ((1 / this.pdfCalc(y, n - 1)) + this.a(n) * ((n - 1) / 2) * Math.pow(y - 0.5, (n - 3) / 2));
    };
    MetaLog.prototype.cdfEven = function (y, n) {
        return this.cdfCalc(y, n - 1) + this.a(n) * Math.pow(y - 0.5, (n / 2) - 1) * this.logTerm(y);
    };
    MetaLog.prototype.pdfEven = function (y, n) {
        var term1 = 1 / this.pdfCalc(y, n - 1);
        var term2 = Math.pow(y - 0.5, (n / 2) - 1) / (y * (1 - y));
        var term3 = (n / 2 - 1) * Math.pow(y - 0.5, n / 2 - 2) * Math.log(y / (1 - y));
        return 1 / (term1 + this.a(n) * (term2 + term3));
    };
    return MetaLog;
}(Distribution));
exports.MetaLog = MetaLog;
var FailureBranch = /** @class */ (function () {
    function FailureBranch() {
    }
    FailureBranch.sumProbability = function (failureBranchStages) {
        var sum = 0;
        failureBranchStages.forEach(function (stage) {
            sum += stage.probability;
        });
        return sum;
    };
    FailureBranch.sumSubtractionValue = function (failureBranchStages) {
        var sum = 0;
        failureBranchStages.forEach(function (stage) {
            sum += stage.value;
        });
        return sum;
    };
    FailureBranch.arrayFailureBranchPoints = function (failureBranchStages) {
        for (var j = 0; j < failureBranchStages.length; j++) {
            failureBranchStages[j].value =
                -failureBranchStages[j].value;
        }
        return failureBranchStages;
    };
    return FailureBranch;
}());
exports.FailureBranch = FailureBranch;
exports["default"] = MetaLog;
//# sourceMappingURL=metalog.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/metalog/app/js/logic/metalog.js